/**
 * @Author: mojeujun
 * @Date: 2025-06-03 17:37:18
 * @Explain: WhatsApp活动
 */
import type { TemplateItem } from '@/api/whatsAppTemplate/data.d';
import { nxcloudToSmartlinkLanguage } from '@/pages/activityWhatsApp/utils/const/create';
import { isObjectLen } from '@/utils/common/dataJudgment';
import http from '../http-nest';
import type {
  Campaign,
  CreateCampaignParams,
  CreateCampaignRes,
  ListParams,
  ListRes,
  SenderPhoneNumberRes,
} from './data.d';
import { CampaignStatus } from './data.d';
const MODEL = '/campaign';
const GAMES_MODEL = '/games';
export default {
  // 获取列表
  async getList(data: ListParams): Promise<ListRes> {
    if (!data.status) {
      Reflect.deleteProperty(data, 'status');
    } else {
      const statusList = [];

      data.status === CampaignStatus.ONGOING &&
        statusList.push(CampaignStatus.PAUSED, CampaignStatus.ERROR);
      data.status === CampaignStatus.COMPLETED &&
        statusList.push(CampaignStatus.CANCELLED);
      statusList.push(data.status);

      Reflect.deleteProperty(data, 'status');
      Reflect.set(data, 'statusList', statusList);
    }
    const res = await http.post(`${MODEL}/list`, data);
    return {
      ...res,
      data: {
        data: res.data.data,
        pageInfo: {
          pageNum: res.data.pageNum,
          pageSize: res.data.pageSize,
          total: res.data.total,
          totalPages: res.data.totalPages,
        },
      },
    };
  },
  // 创建campaign
  create(data: CreateCampaignParams): Promise<CreateCampaignRes> {
    return http.post(`${MODEL}/create`, data);
  },
  // 更新campaign
  update(data: Record<any, any>): Promise<any> {
    return http.post(`${MODEL}/update`, data);
  },
  // 获取详情
  getDetails(id: number): Promise<{ data: Campaign }> {
    return http.post(`${MODEL}/detail`, {
      id,
    });
  },
  // 获取报表
  async getReport(id: number): Promise<any> {
    const result = await http.post(`${MODEL}/report`, {
      id,
    });
    if (result.data.metrics && isObjectLen(result.data.metrics)) {
      const { metrics } = result.data;
      const deliveredCount = metrics['已送达'] || 0;
      const readCount = metrics['已读数'] || 0;
      if (readCount > deliveredCount) {
        result.data.metrics['已送达'] = readCount;
      }
    }

    return result;
  },
  // 删除
  delete(id: number): Promise<{ success: boolean; message: string }> {
    return http.post(`${MODEL}/delete`, {
      id,
    });
  },
  // 确认
  confirm(id: number): Promise<any> {
    return http.post(
      `${MODEL}/confirm`,
      {
        id,
      },
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
  // 获取发送方号码
  getSenderPhoneNumber(): Promise<SenderPhoneNumberRes> {
    return http.get(`${GAMES_MODEL}/sender-phone-numbers`);
  },
  // 获取内容模板
  async getContentTemplate(data: any): Promise<any> {
    const result = await http.get(`${GAMES_MODEL}/templates`, {
      params: data,
    });
    const processedData = result.data.map((item: any) => {
      return {
        ...item,
        language: nxcloudToSmartlinkLanguage(item.language),
      };
    });
    return {
      ...result,
      data: processedData,
    };
  },
  // 校验活动名称是否重复
  checkName(name: string): Promise<{
    exists: boolean;
    message: string;
  }> {
    return http.post(
      `${MODEL}/check-name`,
      {
        name,
      },
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
  // 暂停
  pause(id: number): Promise<any> {
    return http.post(`${MODEL}/pause`, {
      id,
    });
  },
  // 重启
  resume(id: number): Promise<any> {
    return http.post(`${MODEL}/resume`, {
      id,
    });
  },
  // 终止
  cancel(id: number): Promise<any> {
    return http.post(`${MODEL}/cancel`, {
      id,
    });
  },
  // 撤销
  revoke(id: number): Promise<any> {
    return http.post(`${MODEL}/revoke`, {
      id,
    });
  },
  // 获取模板信息
  getTemplateInfos(nxcloudTemplateIdList: string[]): Promise<TemplateItem> {
    return http.post(`${MODEL}/template-infos`, { nxcloudTemplateIdList });
  },
};
